//renamed this file so it doesn't get added to routes
//epic-48417 was merged into dev before it's ready so we could get some component updates
export default [
	{
		path: 'accounting/accountspayable/processpayments',
		name: 'process-payments',
		meta: {
			pageTitle: 'Post Payments',
			displayConcurrentUsers: true
		},
		props: route => ({
			searchParams: route.query,
			companyId: parseInt(route.params.companyid),
			tab: route.query.tab ? parseInt(route.query.tab) : undefined,
			view: route.query.view || undefined,
			view2: route.query.view2 || undefined
		}),
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(
				/* webpackChunkName: "processPayments" */ '@/sections/accounting/accounts-payable/process-payments/process-payments-page.vue'
			)
	},
	{
		path: 'accounting/accountspayable/processpayments/processing',
		name: 'payments-processing',
		meta: {
			pageTitle: 'Payments Posting'
		},
		props: route => ({
			companyId: parseInt(route.params.companyid)
		}),
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(
				/* webpackChunkName: "paymentsProcessing" */ '@/sections/accounting/accounts-payable/process-payments/payments-processing-page.vue'
			)
	}
];
